import { spawn } from "redux-saga/effects"

import { createCafeReferralSaga } from "./createCafeReferralSaga"

export default [spawn(createCafeReferralSaga)]
